/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    blockquote: "blockquote",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "\"innerRef\""
      }), " 属性(", _jsx(_components.code, {
        children: "\"innerRef\""
      }), " prop)"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "\"innerRef\""
      }), " prop"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "\"innerRef\""
        }), " 属性在 styled-components v4 中被删除，取而代之的是 ", _jsxs(_components.a, {
          href: "https://react.nodejs.cn/docs/forwarding-refs.html",
          children: ["React 16 ", _jsx(_components.code, {
            children: "forwardRef"
          }), " API"]
        }), "。只需使用普通的 ", _jsx(_components.code, {
          children: "ref"
        }), " 属性即可。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥The ", _jsx(_components.code, {
          children: "\"innerRef\""
        }), " prop was removed in styled-components v4 in favor of the ", _jsxs(_components.a, {
          href: "https://react.nodejs.cn/docs/forwarding-refs.html",
          children: ["React 16 ", _jsx(_components.code, {
            children: "forwardRef"
          }), " API"]
        }), ". Just use the normal ", _jsx(_components.code, {
          children: "ref"
        }), " prop instead."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["将 ", _jsx(_components.code, {
        children: "ref"
      }), " 属性传递给样式化组件将为你提供 ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " 封装器的实例，但不会传递给底层 DOM 节点。这是由于裁判的工作方式造成的。不可能在我们的封装器上直接调用 DOM 方法，例如 ", _jsx(_components.code, {
        children: "focus"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Passing a ", _jsx(_components.code, {
        children: "ref"
      }), " prop to a styled component will give you an instance of\nthe ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " wrapper, but not to the underlying DOM node.\nThis is due to how refs work.\nIt's not possible to call DOM methods, like ", _jsx(_components.code, {
        children: "focus"
      }), ", on our wrappers directly."]
    }), "\n", _jsxs(_components.p, {
      children: ["要获取对实际的、封装的 DOM 节点的引用，请将回调传递给 ", _jsx(_components.code, {
        children: "innerRef"
      }), " 属性。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To get a ref to the actual, wrapped DOM node, pass the callback to the ", _jsx(_components.code, {
        children: "innerRef"
      }), " prop instead."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["我们不支持字符串引用（即 ", _jsx(_components.code, {
          children: "innerRef=\"node\""
        }), "），因为它们在 React 中已被弃用。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥We don't support string refs (i.e. ", _jsx(_components.code, {
          children: "innerRef=\"node\""
        }), "), since they're already deprecated in React."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["此示例使用 ", _jsx(_components.code, {
        children: "innerRef"
      }), " 保存对样式输入的引用，并在用户将鼠标悬停在其上时将其聚焦。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This example uses ", _jsx(_components.code, {
        children: "innerRef"
      }), " to save a ref to the styled input and focuses it once the user\nhovers over it."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Input = styled.input`\n  padding: 0.5em;\n  margin: 0.5em;\n  color: #BF4F74;\n  background: papayawhip;\n  border: none;\n  border-radius: 3px;\n`\n\nclass Form extends React.Component {\n  render() {\n    return (\n      <Input\n        placeholder=\"Hover here...\"\n        innerRef={x => {\n          this.input = x\n        }}\n        onMouseEnter={() => this.input.focus()}\n      />\n    )\n  }\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
